import { logout } from "../app/features/userSlice"
import { routeForStatus } from "../app/features/subscriptionStatusSlice"

export const handleAPIError = (error, { dispatch, navigate, openErrorSnackbar }, isHome = false) => {
  if (error.response.status === 401) {
    dispatch(logout())
    return
  }
  if (error.response.status === 403) {
    navigate(routeForStatus(error?.response?.data?.status))
    return
  }

  if (error.response.status === 423) {
    navigate("/collect-tax-id")
    return
  }

  if (!isHome) {
    navigate("/")
    return
  }

  openErrorSnackbar("Ocorreu um erro inesperado")
  return
}
